<div style="margin-left: 0px;" class="content-wrapper" id="content-wrapper">
  <section class="content-header">
    <h1>
      Atestado
    </h1>
    <ol class="breadcrumb">
      <li><i class="fa fa-dashboard"></i>&nbsp;&nbsp;&nbsp;Home</li>
      <li>Lançamento</li>
      <li class="active">Atestado</li>
    </ol>
  </section>

  <!-- modalp popup ends -->
  <section class="content">

    <form id="formulario">
      <div style="margin-left: 0px;">
        <div class="box box-primary">
          <div class="box-body">                                                        
            <div class="row">      
                <div class="col-md-4">
                    <div class="form-group">            
                        <label>Data</label>                                    
                        <div class="input-group date">
                            <input type="text" mask="00/00/0000" autocomplete="off" class="form-control pull-right" id="txtData" name="txtData" placeholder="dd/mm/yyyy">
                            <div class="input-group-addon">
                                <i class="fa fa-calendar"></i>
                            </div>                    
                        </div> 
                    </div>                            
                </div>                                                              
                <div class="col-md-4">           
                    <div class="form-group">            
                        <label>Horário da Chegada</label>        
                        <input type="text" mask="00:00" class="form-control" id="txtHoraChegada" name="txtHoraChegada" placeholder="__:__">                                                          
                    </div>                                
                </div>
                <div class="col-md-4">
                    <div class="form-group">            
                        <label>Horário da Saída</label>                                    
                        <input type="text" mask="00:00" class="form-control" id="txtHoraSaida" name="txtHoraSaida" placeholder="__:__">
                    </div>                            
                </div>                                
            </div>    
            <div class="row">      
                <div class="col-md-4">
                    <div class="form-group">            
                        <label>Quantidade de Dias</label>                                    
                        <input type="text" class="form-control" id="txtQtdDias" name="txtQtdDias" placeholder="0">
                    </div>                              
                </div> 
                <div class="col-md-4">
                    <div class="form-group">            
                        <label>CID (Classificação Internacional de Doenças)</label>                                    
                        <input type="text" class="form-control" id="txtCID" name="txtCID" placeholder="CID">
                    </div>                              
                </div>   
                <div class="col-md-4">
                    <div class="form-group">            
                        <label>Anexar</label>                                    
                        <div class="input-group date">
                          <input disabled style="background-color: white;" type="text" class="form-control pull-right"
                            id="txtFoto" name="txtFoto" placeholder="Escolher Arquivo">
                          <div class="input-group-addon" style="padding: 0px;">
                            <div class="fa fa-upload btn btn-file">
                              <input class="ignore" type="file" name="inputFoto" #imageInput type="file"
                                (change)="processFile(imageInput)">
                            </div>
                          </div>
                        </div>
                    </div>                              
                </div>                                                                                                                                                                            
            </div>                                                                                                                                                         
        </div>

          <div class="box-footer">
            <table border=0 width="100%">
              <tr width="100%">
                <td align="left"><button type="reset" (click)="clearInputvalues()"
                    class="btn btn-default">Limpar</button>
                </td>
                <td align="center"><span id="spanErro" name="spanErro" class="error" style="font-weight: bold;"></span>
                </td>
                <td align="right">
                  <input value="Lançar" readonly="readonly"  (click)="lancar()" class="btn btn-info pull-right btn-margin" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="box box-body">
        <div style="overflow-y: auto;">
          <div style="width: 99%; padding-left: 15px;">
            <table #grid style="width: 100% !important;" class="table table-bordered table-striped">
              <thead>
                <tr>  
                  <th style="width: 15% !important">Data</th>
                  <th style="width: 15% !important">Horário de Chegada</th>
                  <th style="width: 15% !important">Horário de Saída</th>
                  <th style="width: 15% !important">Quantidade de Dias</th>
                  <th style="width: 15% !important">CID</th>                     
                  <th style="width: 15% !important">Anexo</th>       
                  <th style="width: 15% !important">Status</th>                                
                  <th style="width: 15% !important">Data da Conclusão</th>      
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </form>
  </section>

  <div class="control-sidebar-bg"></div>
</div>